import { render, staticRenderFns } from "./NewMessageDialog.vue?vue&type=template&id=7437dd7a&scoped=true&"
import script from "./NewMessageDialog.vue?vue&type=script&lang=js&"
export * from "./NewMessageDialog.vue?vue&type=script&lang=js&"
import style0 from "./NewMessageDialog.vue?vue&type=style&index=0&id=7437dd7a&prod&lang=css&"
import style1 from "./NewMessageDialog.vue?vue&type=style&index=1&id=7437dd7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7437dd7a",
  null
  
)

export default component.exports